"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ListingsContainer = _interopRequireDefault(require("./ListingsContainer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _ListingsContainer.default;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./lib/listings/index.js
// module id = 239
// module chunks = 0